'use client'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => (
  <div className='fixed z-[99] inset-0 pointer-events-none has-[button[data-hide=true]]:hidden'>
    <Sonner
      theme='dark'
      className='toaster group min-w-[400px] h-20 font-[inherit] pointer-events-auto'
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'group w-full h-20 toast group-[.toaster]:border group-[.toaster]:bg-surface2-100 group-[.toaster]:border-border1 group-[.toaster]:rounded-2xl group-[.toaster]:shadow-lg',
        },
      }}
      {...props}
    />
  </div>
)

export { Toaster }
